import { useState, useRef } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import RenderIf from "../RenderIf";
import ProgressBar from "../ProgressBar";

const ImageChanger = ({ onChange, image }) => {

    const [imageUrl, setImageUrl] = useState(image);
    const [isCarging, setIsCarging] = useState(false);

    const fileInput = useRef();

    const storage = getStorage();
    const imgRef = ref(storage, `images/${Date.now()}.png`);

    const handleChange = (e) => {
        setIsCarging(true);
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setImageUrl(reader.result);
        }

        uploadBytes(imgRef, file)
            .then(url => {
                return getDownloadURL(imgRef);
            })
            .then(url => {
                onChange({
                    target: {
                        name: "image",
                        value: url
                    }
                });
                setIsCarging(false);
            })
    }

    return (
        <div className="image-changer h-75">
            { imageUrl ? <img src={imageUrl} alt='..' /> : <i className=" fs-1 bi bi-image"></i>}
            <ul className="nav">
                <li
                    onClick={() => fileInput.current.click()}
                    className="nav-item">
                    <i className="bi bi-pencil" />
                </li>
            </ul>
            <input
                type="file"
                ref={fileInput}
                className="d-none"
                accept="image/*"
                onChange={(e) => handleChange(e)}
            />
            <RenderIf condition={isCarging} >
                <ProgressBar />
            </RenderIf>
        </div>
    )
}

export default ImageChanger;